// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__23YN4","ranges":"BmiRanges_ranges__1AeHI"};